import styled from "styled-components";

import { fontSizes } from "../../../shared/styles/typography";

import { tokens } from "../../../theme/tokens";

const BP = tokens.layout.mobileFirstExpandPx;

export const SearchWrapper = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.card};
  padding: 16px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const SearchContent = styled.div`
  max-width: var(--layout-app-shell-max);
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;

  @media (min-width: ${BP}px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const LettersContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 8px;
  padding: 8px 0;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const LetterItem = styled.button<{ active?: boolean }>`
  min-width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.active
      ? props.theme.colors.primary
      : props.theme.colors.surfaceSecondary};
  color: ${(props) =>
    props.active
      ? props.theme.colors.titleOnPrimary
      : props.theme.colors.textSecondary};
  border: none;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${(props) =>
      props.active
        ? props.theme.colors.primary
        : props.theme.colors.surfaceTertiary};
  }
`;

export const VerbeteCard = styled.div`
  background: ${({ theme }) => theme.colors.card};
  border-radius: 20px;
  padding: 16px;
  box-shadow: ${({ theme }) => theme.shadows.md3Level1};
  border: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.2s;

  &:active {
    transform: scale(0.98);
  }

  .card-main {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .media-box {
    width: 100%;
    aspect-ratio: 4 / 3;
    max-height: 220px;
    background: ${({ theme }) => theme.colors.surfaceSecondary};
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
    border: 1px solid ${({ theme }) => theme.colors.border};

    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: ${({ theme }) => theme.colors.surfaceSecondary};
    }

    .letter-fallback {
      width: 100%;
      height: 100%;
      background: ${({ theme }) => theme.colors.primary};
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: ${fontSizes["3xl"]}px;
      font-weight: var(--font-weight-bold);
      color: ${({ theme }) => theme.colors.titleOnPrimary};
    }
  }

  .card-body {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;

    h3 {
      font-size: ${fontSizes.base}px;
      font-weight: var(--font-weight-semibold);
      color: ${({ theme }) => theme.colors.textTitle};
      margin: 0;
    }

    p {
      font-size: ${fontSizes.sm}px;
      color: ${({ theme }) => theme.colors.textSecondary};
      margin: 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .variant-tag {
    background: ${({ theme }) =>
      `color-mix(in srgb, ${theme.colors.primary} 12%, transparent)`};
    color: ${({ theme }) => theme.colors.primary};
    padding: 2px 8px;
    border-radius: 6px;
    font-size: ${fontSizes.xs}px;
    font-weight: 600;
    align-self: flex-start;
    border: 1px solid
      ${({ theme }) =>
        `color-mix(in srgb, ${theme.colors.primary} 22%, transparent)`};
  }

  .favorite-action {
    background: ${({ theme }) => theme.colors.surfaceSecondary};
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.2s;

    &:hover {
      background: ${({ theme }) => theme.colors.surfaceTertiary};
    }
  }

  .card-footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
    border-top: 1px solid ${({ theme }) => theme.colors.border};
  }

  .dactylology-btn {
    height: 36px;
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.primary} !important;
    border: none;
    font-weight: 600;
  }
`;

export const VerbeteListGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: ${BP}px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const ListPageBody = styled.div`
  padding: 0 16px;
  margin-top: 16px;
  max-width: var(--layout-app-shell-max);
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: ${BP}px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
